/**
 * Application Name Enum
 * 
 * Defines the available application names in the system.
 * Use this enum for type-safe app name references across environments.
 */
export enum AppName {
  Hayagriva = 'hayagriva'
}
